/* eslint-disable  no-shadow */
/* eslint-disable  no-unsafe-optional-chaining */

import {
  MaskedInput,
  Select,
  ButtonNext,
  MaskedInput2,
  Select2,
} from 'components/index'
import { UserContext } from 'context/userContext'
import useFetch from 'hooks/useFetch'
import { useContext, useEffect, useState, useRef, useCallback } from 'react'
import { Form } from '@unform/web'
import { Icon } from 'assets/index'
import * as Yup from 'yup'
import {
  addRow,
  removeRow,
  handleChangeUnit,
  calculateDates,
  calculateRentabilidade,
  schemaRetroativos,
} from './factory'
import ClientSelection from './ClientSelection'
import {
  CondiCaptacaoRetroativo,
  DadosContratoRetroativo,
  DadosEmpreeendimentoRetroativo,
  InfoContratoRetroativo,
  JustGuarantee,
  RentabilidadeRetroativo,
} from './CaptionData'
import { Unidade, InputError } from './style'

interface UnitRow {
  unit: string | null
  percent: string | null
  quotas: number | null
  id: string
}

interface ProfRow {
  months: any | null
  prof: string | null
  id: string
}

interface ValidationErrors {
  [key: string]: string
}

const Retroativos = (props: any) => {
  const { retroData, setRetroData, requestFn, feedback, setPage, showModal } =
    useContext(UserContext)
  const [enterprises, setEnterprises] = useState<any>([])
  const formRef = useRef<HTMLFormElement | any>(null)
  const [profError, setProfError] = useState<boolean | string>(false)
  const [prof, setProf] = useState<ProfRow[]>([
    { months: null, prof: null, id: `prof_1` },
  ])
  const [uniRows, setUniRows] = useState<UnitRow[]>([
    { unit: null, percent: null, quotas: null, id: `row_1` },
  ])
  const api = useFetch()

  const getEnterprises = useCallback(async () => {
    try {
      const res = await api.fetch(
        'get',
        null,
        '/gestor/retroactive/enterprise-list'
      )
      // console.log(res)
      setEnterprises(
        res.data.map((item: any) => {
          return {
            ...item,
            label: item.name,
            value: item.id,
          }
        })
      )
    } catch (err) {
      console.log(err)
    }
  }, [setEnterprises])

  useEffect(() => {
    const cooldown = setTimeout(getEnterprises, 200)
    return () => {
      clearTimeout(cooldown)
    }
  }, [])

  useEffect(() => {
    // Total de cotas
    const max = Number(retroData?.value) / Number(retroData?.quotaValue)
    if (Number.isNaN(max) || !Number.isFinite(max)) {
      return setRetroData((oldValue: any) => ({
        ...oldValue,
        amount: null,
      }))
    }
    return setRetroData((oldValue: any) => ({
      ...oldValue,
      amount: Number(retroData?.value) / Number(retroData?.quotaValue),
    }))
  }, [retroData?.quotaValue, retroData?.value])

  useEffect(() => {
    // Datas
    if (
      !retroData?.firstAt ||
      !retroData?.cotizationOut ||
      !retroData?.deadline ||
      !retroData?.investAt
    )
      return

    calculateDates(retroData, setRetroData)
  }, [
    retroData?.firstAt,
    retroData?.cotizationOut,
    retroData?.deadline,
    retroData?.investAt,
    // retroData,
  ])

  useEffect(() => {
    // console.log('setar taxa ponderada e rentabilidades')
    const somaJuros = prof.reduce((sum: number, item: any) => {
      return sum + (Number(item.prof) * Number(item.months) ?? 0)
    }, 0)

    let jurosaa = (somaJuros / Number(retroData?.deadline)) * 12

    // const jurosaa = (somaJuros / prof.length) * 12

    if (Number.isNaN(jurosaa)) return

    jurosaa = Math.round(jurosaa * 100) / 100

    setRetroData((old: any) => ({
      ...old,
      profitability: jurosaa,
    }))

    if (
      !retroData?.firstAt ||
      !retroData?.deadline ||
      !retroData?.investAt ||
      !retroData?.profitability ||
      !retroData?.value
    )
      return

    calculateRentabilidade(retroData, setRetroData, prof)
  }, [
    prof,
    retroData?.firstAt,
    retroData?.deadline,
    retroData?.investAt,
    retroData?.profitability,
    retroData?.value,
  ])

  const getAvailableMonths = () => {
    if (!retroData?.deadline) return []
    const arr = []
    const soma = prof.reduce((soma: number, item: any) => {
      return soma + (Number(item.months || 0) ?? 0)
    }, 0)
    // console.log(sum)
    const monthsAv = Number(retroData?.deadline) - soma
    for (let i = 0; i < monthsAv; i++) {
      arr.push({
        label: i + 1,
        value: i + 1,
      })
    }
    return arr
  }

  // FORMATA O retroData PARA PEGAR SO O VALUE DE CHAVES SELECT
  // ex:  type: { label: 'Cotas imobiliárias', value: 'SPE' } para { type: 'SPE' }
  const extractValues = (obj: any) => {
    if (!obj) return {}
    const extractedObj: any = {}

    Object.entries(obj).forEach(([key, value]: any) => {
      if (!value) return
      if (typeof value === 'object' && 'value' in value) {
        extractedObj[key] = value.value
      } else {
        extractedObj[key] = value
      }
    })

    return extractedObj
  }

  const setCallbackForCreateRetroativo = () => {
    const formatedProf = prof.map((item: any) => {
      return [Number(item?.months), Number(item.prof)]
    })
    const formatedUnit = uniRows.map((row: any) => {
      return [Number(row.unit), Number(row.percent)]
    })

    const dataBody = {
      ...extractValues(retroData),
      value: Number(retroData.quotaValue),
      unityList: formatedUnit,
      paymentConditions: formatedProf,
      isCotizationProfitable: retroData.isCotizationProfitable === 1,
      guaranteeList:
        retroData?.guaranteeList?.value === 'Não possui'
          ? []
          : [retroData?.guaranteeList?.value],
    }

    console.log(dataBody)

    feedback.current = { title: 'Investimento criado!', error: false }

    requestFn.current = async () => {
      try {
        const response: any = await api.fetch(
          'post',
          dataBody,
          '/gestor/retroactive'
        )
        console.log('resposta retroativo', response)
        return response
      } catch (err: any) {
        console.log('err', err)
        return err
      }
    }
  }

  const handleSubmit = async () => {
    try {
      // Remove all previous errors
      formRef.current.setErrors({})
      setProfError(false)

      await schemaRetroativos.validate(retroData, { abortEarly: false })

      let err = false

      prof.forEach((juros: any) => {
        if (
          !juros.months ||
          juros.months === '' ||
          !juros.prof ||
          juros.prof === ''
        ) {
          err = true
        }
        // setProfError(false)
      })

      if (err) return setProfError('Preenchimento completo obrigatório')

      const sum = prof.reduce((sum: number, item: any) => {
        return sum + (Number(item.months) ?? 0)
      }, 0)

      if (sum !== Number(retroData?.deadline))
        return setProfError('Complete os meses do prazo')

      setCallbackForCreateRetroativo()

      setPage(1)
    } catch (err) {
      console.log(err)
      const validationErrors: ValidationErrors = {}
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path] = error.message
          }
        })
        console.log('aloooooo', validationErrors)
        formRef.current.setErrors(validationErrors)
      }
    }
  }

  return (
    <Form ref={formRef} onSubmit={() => console.log('submit')}>
      {/* {console.log(retroData, prof, uniRows)} */}
      <Select2
        placeholder="Selecionar empreendimento"
        dataTestId="select-enterprise-select"
        large
        hasAsterisk
        name="enterpriseId"
        options={enterprises}
        onChange={(e: any) =>
          setRetroData((old: any) => ({
            ...old,
            enterpriseId: e.value,
            name: e.name,
            short: e.short,
            tick: e.tick,
          }))
        }
        value={enterprises?.find(
          (empre: any) => empre.id === retroData?.enterpriseId
        )}
      />

      <DadosEmpreeendimentoRetroativo />

      <div className="new-token-subtitle">
        <h4>Selecionar cliente</h4>
      </div>
      <div className="new-token-checkbox">
        <ClientSelection isRetroativo />
      </div>

      <CondiCaptacaoRetroativo />

      <div className="new-token-subtitle">
        <h4>Unidade do empreendimento</h4>
      </div>
      <div className="new-token-container">
        {uniRows.map((item: UnitRow, index: number) => {
          return (
            <Unidade key={item.id}>
              <MaskedInput2
                large
                dataTestId="number-unit-input"
                type="number"
                handleChange={(e: any) => {
                  handleChangeUnit({
                    index,
                    name: 'unit',
                    value: e,
                    arr: uniRows,
                    setArr: setUniRows,
                    unit: true,
                    data: retroData,
                  })
                }}
                placeholder={'Número da unidade do empreendimento'}
                name="unit"
                defaultValue={item?.unit}
              />
              <MaskedInput2
                small
                dataTestId="percent-input"
                type="jurosaa"
                handleChange={(e: any) => {
                  handleChangeUnit({
                    index,
                    name: 'percent',
                    value: e,
                    arr: uniRows,
                    setArr: setUniRows,
                    unit: true,
                    data: retroData,
                  })
                }}
                placeholder="% da unidade"
                name="percent"
                defaultValue={item?.percent}
              />
              <MaskedInput2
                type="text"
                large
                dataTestId="quotas-amout-input"
                disabled
                handleChange={(e: any) => {
                  console.log(e)
                }}
                placeholder="Quantidade de cotas"
                name="quotas"
                defaultValue={item?.quotas}
              />
              <img
                style={{
                  width: 20,
                  height: 20,
                  marginBottom: 12,
                  cursor: 'pointer',
                }}
                src={Icon('trash.svg')}
                alt="card icon"
                onClick={() =>
                  removeRow(item, uniRows, setUniRows, retroData, true)
                }
              />
            </Unidade>
          )
        })}
        <div className="new-plus-icon">
          <img
            style={{
              width: 15,
              height: 15,
              cursor: 'pointer',
            }}
            src={Icon('plus.svg')}
            alt="card icon"
            onClick={() => addRow(true, setUniRows, uniRows)}
          />
        </div>
      </div>

      <InfoContratoRetroativo />

      <div className="new-token-subtitle">
        <h4>Condições da Rentabilidade</h4>
        {/* *******************************************************
        ATENCAO, VERIFICAR SE A SOMA DA DISTRIBUICAO DE MESES E IGUAL AO PRAZO TOTAL
        FEEDBACK DE ERRO
        ******************************************************* */}
      </div>
      {profError && <InputError>{profError}</InputError>}
      <div className="new-token-container">
        {prof.map((item: ProfRow, index: number) => {
          return (
            <Unidade key={item.id}>
              <div>
                <Select2
                  dataTestId="select-months"
                  small
                  key={`${item.id}+select`}
                  placeholder="Meses"
                  name={'months'}
                  options={getAvailableMonths()}
                  onChange={(e: any) => {
                    handleChangeUnit({
                      index,
                      name: 'months',
                      value: e.value,
                      arr: prof,
                      setArr: setProf,
                      unit: false,
                      data: retroData,
                    })
                  }}
                  value={getAvailableMonths().find(
                    (mes: any) => mes.value === item?.months
                  )}
                />
              </div>
              <MaskedInput2
                dataTestId="juros-aa-input"
                small
                type="jurosaa"
                handleChange={(e: any) => {
                  handleChangeUnit({
                    index,
                    name: 'prof',
                    value: String(Number(e / 12)),
                    arr: prof,
                    setArr: setProf,
                    unit: false,
                    data: retroData,
                  })
                }}
                placeholder="Juros a.a."
                name="prof"
                defaultValue={
                  Number(item?.prof) * 12 === 0 ? null : Number(item?.prof) * 12
                }
              />
              <span
                className="new-token-plus"
                style={{ marginTop: 0, marginBottom: 12 }}
              >
                %
              </span>
              <img
                style={{
                  width: 20,
                  height: 20,
                  marginBottom: 12,
                  cursor: 'pointer',
                }}
                src={Icon('trash.svg')}
                alt="card icon"
                onClick={() => removeRow(item, prof, setProf, retroData, false)}
              />
            </Unidade>
          )
        })}
        <div className="new-plus-icon">
          <img
            style={{
              width: 15,
              height: 15,
              cursor: 'pointer',
            }}
            src={Icon('plus.svg')}
            alt="card icon"
            onClick={() => addRow(false, setProf, prof)}
          />
        </div>
      </div>

      <JustGuarantee />

      <DadosContratoRetroativo />

      <RentabilidadeRetroativo />

      <ButtonNext isAdvance advancePage={() => handleSubmit()} />
    </Form>
  )
}

export default Retroativos
